import api from './api';

const vaultsqlsearchService = {
  search: async (vaultid, vaultsqlid, paramValues) => {
    const response = await api.post('/vaultsqlsearch', { vaultid, vaultsqlid, paramValues });
    return response.data;
  }
};

export default vaultsqlsearchService;
